import { faArrowDown, faArrowUp, faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import Modal from "../modal/modal";
import ViewCddPipeline from "../modal/pipline-modal/ViewCddPipeline";
import { api, getToken } from "../../../services/apis/auth-api/apiUrl";
import { PIPE_LINE_GET_CDD_PIPELINE } from "../../../config/config";
import DeleteCdd from "../modal/pipline-modal/DeleteCdd";
import { useAuth } from "../../../services/auth-services/authContext";
import { AuthContextState } from "../../../utils/types";

interface PipelineData {
  pipeline_id : number;
  cdd_name: string;
  client_id : number;
  role : string;
  revenue: string;
  processed_date: string; 
  status: number;
  notes: string;
  projected_start_date: string; 
  client_name: string;
  career_level: string;
  cdd_num: string;
  add_candidates_or_switch_roles: string;
  last_update : string;
}

interface props {
    u_id : number;
    year : number;
    filter : number[];
    filterCol : string[];
    searchFilter : string;
    newCddAdded : boolean;
    pipeline : (data : PipelineData[]) => void;
    full_access : boolean;
}

const CddPipeLineTable : React.FC<props> = ({ u_id, year, filter, filterCol, searchFilter, newCddAdded, pipeline, full_access }) => {
    const { decodedJwtData } = useAuth() as AuthContextState;
    const save_boolean = localStorage.getItem('latest_boolean');
    const last_sort_bool = save_boolean ? JSON.parse(save_boolean).latest : true;
    const [showModal, setShowModal] = useState<boolean>(false);
    const [modalChildren, setModalChildren] = useState<React.JSX.Element | null>(null);
    const [pipeline_data, set_pipeline_data] = useState<PipelineData[] | null>(null);
    const [db_pipeline, set_db_pipeline] = useState<PipelineData[] | null>(null);
    const [dateUpdatedToLatest, setdateUpdatedToLatest] = useState<boolean>(last_sort_bool);
    const [ privArray ] = useState<number[] | undefined>(decodedJwtData?.account_priv ?? []);

    function createModalContent(content : React.JSX.Element){
        setModalChildren(content);
        setShowModal(true);
    }

    useEffect(()=>{
        const handleSearchCdd = () => {
            if(!pipeline_data) return false;
            const search = searchFilter.toLowerCase();
            const cdd = pipeline_data.filter(pipeline => pipeline.cdd_name.toLowerCase().includes(search));
            set_pipeline_data(cdd);
        }
        handleSearchCdd();
    },[pipeline_data, searchFilter]);

    useEffect(()=>{
        const handleFilter = () => {
            let filteredPipeline = db_pipeline?.filter(data => filter.includes(data.status));
            if(dateUpdatedToLatest) filteredPipeline = filteredPipeline?.sort((a, b) =>
                new Date(b.last_update).getTime() - new Date(a.last_update).getTime()
            )
            if(!dateUpdatedToLatest) filteredPipeline = filteredPipeline?.sort((a, b) =>
                new Date(a.last_update).getTime() - new Date(b.last_update).getTime()
            )
            if(filteredPipeline) set_pipeline_data(filteredPipeline);
            if(filter.length === 0) set_pipeline_data([]);
            localStorage.setItem('latest_boolean', JSON.stringify({latest : dateUpdatedToLatest}));
        }
        if(searchFilter === '') handleFilter();
    },[dateUpdatedToLatest, db_pipeline, filter, searchFilter]);

    useEffect(()=>{
        const getPipeLineData = async() => {
            set_pipeline_data(null);
            try{
                const pipeline_res = await api.get(
                    PIPE_LINE_GET_CDD_PIPELINE+u_id+'/'+year, {
                        headers : {'Authorization' : 'Bearer '+getToken()}
                    }
                );
                const data = pipeline_res.data as PipelineData[];
                set_db_pipeline(data);
                pipeline(data);
            }catch(e){}
        }
        if(!showModal || !newCddAdded) getPipeLineData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[newCddAdded, showModal, u_id, year]);

    return (
        <div className="border-t">
            <div className="table-container overflow-x-auto">
                <table className="w-full h-full border">
                    <thead className="table-fixed-header border">
                        <tr className="bg-gray-100 text-sm">
                            <th className='table-headers font-medium'>Action</th>
                            <th className='table-headers font-medium'>
                                <div className="flex gap-2 justify-center items-center">
                                    <h2>Date Updated</h2>
                                    <button onClick={()=>setdateUpdatedToLatest(dateUpdatedToLatest ? false : true)}>
                                        <FontAwesomeIcon icon={dateUpdatedToLatest ? faArrowUp : faArrowDown} />
                                    </button>
                                </div>
                            </th>
                            <th className='table-headers font-medium'>Candidate Name</th>
                            {filterCol.map(col => (
                                <>
                                    <th className='table-headers font-medium'>{col}</th>
                                </>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        {pipeline_data && pipeline_data.length > 0 ? pipeline_data.map(data => (
                            <tr className="hover:bg-gray-300">
                                <td className='table-body px-2'>
                                    <div className="flex gap-2 justify-center items-center">
                                        <button type="button" onClick={()=>createModalContent(<ViewCddPipeline access={0} pipeline={data} onClose={()=>setShowModal(false)} />)} className="text-blue-500 underline text-xs">
                                            <FontAwesomeIcon icon={faEdit} /> Edit
                                        </button>
                                        {(full_access && privArray?.includes(14)) && (
                                            <button type="button" onClick={()=>createModalContent(<DeleteCdd cip_id={data.pipeline_id} cdd_name={data.cdd_name} showModal={(val)=> setShowModal(val)} />)} className="text-red-400 underline text-xs">
                                                <FontAwesomeIcon icon={faTrashAlt} /> Delete
                                            </button>
                                        )}
                                    </div>
                                    
                                </td>
                                <td className='table-body px-2'>{data.last_update}</td>
                                <td className='table-body px-2'>{data.cdd_name}</td>
                                {filterCol.includes('Processed Date')&&(<td className='table-body px-2'>{data.processed_date}</td>)}
                                {filterCol.includes('Client')&&(<td className='table-body px-2'>{data.client_name}</td>)}
                                {filterCol.includes('Position Title')&&(<td className='table-body px-2'>{data.role}</td>)}
                                {filterCol.includes('Career Level')&&(<td className='table-body px-2'>{data.career_level}</td>)}
                                {filterCol.includes('Status')&&(
                                    <td className='table-body px-2 min-w-44'>

                                        <div className={
                                            `shadow rounded-xl
                                            ${
                                                data.status === 1 ? 'bg-blue-200' :
                                                data.status === 2 ? 'bg-orange-300' :
                                                data.status === 3 ? 'bg-blue-400 text-white' :
                                                data.status === 4 ? 'bg-yellow-400 text-white' : 
                                                data.status === 5 ? 'bg-green-400 text-white' :
                                                data.status === 6 ? 'bg-orange-400 text-white' :
                                                data.status === 7 ? 'bg-red-500 text-white' :
                                                data.status === 8 ? 'bg-red-400 text-white' : 
                                                data.status === 9 ? 'bg-green-500' :
                                                data.status === 10 ? 'bg-gray-400 text-white' : 'bg-red-400 text-white'
                                            }
                                            `}>
                                            {
                                                data.status === 1 ? 'On Initial Stage' :
                                                data.status === 2 ? 'On Mid Stage' :
                                                data.status === 3 ? 'On Final Stage' :
                                                data.status === 4 ? 'For Job Offer' : 
                                                data.status === 5 ? 'Offer Accepted' :
                                                data.status === 6 ? 'Onboarded' : 
                                                data.status === 7 ? 'Withdraw' : 
                                                data.status === 8 ? 'Reneged' : 
                                                data.status === 9 ? 'Source Tagging' :
                                                data.status === 10 ? 'Closed Role' :
                                                data.status === 11 ? 'Offer Rejected' : 'Failed'
                                            }
                                        </div>
                                    </td>
                                )}
                                {filterCol.includes('Start Date')&&(<td className='table-body px-2 min-w-36'>{data.projected_start_date}</td>)}
                                {filterCol.includes('Revenue')&&(<td className='table-body px-2'>{data.revenue !== null ? parseFloat(data.revenue.toString()).toLocaleString("en-US", {minimumFractionDigits : 2, maximumFractionDigits : 2}) : 'N/A'}</td>)}
                            </tr>
                        )) : pipeline_data && pipeline_data.length <= 0 ? (
                            <tr>
                                <td className='table-body px-2' colSpan={11}>No candidate found.</td>
                            </tr>
                        ) : Array.from({length : 3}).map((_, index) => (
                            <tr key={index}>
                                {[...Array(filterCol.length + 3)].map((_, colIndex) => (
                                    <td key={colIndex} className='table-body'>
                                        <div className="table-loading bg-gray-200"></div>
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
                {showModal && (
                    <Modal onClose={()=>{setShowModal(false)}}> 
                        {modalChildren}
                    </Modal>
                )}
            </div>
        </div>
    );
}

export default CddPipeLineTable;